<template lang="pug">
.solicitud(@click="$emit('ver')")
	.contenido
		.titulo {{ solicitud.Titulo }}
		.fechaCreacion
			span.fa.fa-calendar.mr-2
			span Creada el {{ new Date(solicitud.FechaCreacionUnix * 1000) | moment('DD-MM-YYYY') }} a las {{ new Date(solicitud.FechaCreacionUnix * 1000) | moment('HH:mm') }}
		.fechaFinalizacion(:class="!solicitud.FechaPublicacion ? 'danger' : ''")
			span.fa.fa-calendar-times-o.mr-2
			span(v-if="!solicitud.FechaPublicacion") Publicación sin definir
			span(v-else) Finalizada el {{ solicitud.FechaFinalizacion | moment('DD-MM-YYYY') }}
	.avatar
		avatar(:usuario="solicitud.UsuarioID")
		.nombre {{ solicitud.UsuarioNombre }}
</template>

<script>
export default {
	props: ['solicitud']
}
</script>


<style scoped>

.solicitud:nth-child(odd) {
	background-color: #f9f9f9;
}
.solicitud {
	position: relative;
	display: flex;
	flex-direction: row;
	width: 100%;
	cursor: pointer;
}

.solicitud:hover {
	opacity: 0.7;
}

.solicitud > .icono {
	width: 60px;
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 60px;
	align-self: center;
	text-align: center;
	font-size: 3em;
	color: #3D4553;
}

.solicitud > .contenido {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	flex-shrink: 1;
	align-self: flex-start;
	text-align: left;
	font-size: 1em;
	padding: 10px;
}

.solicitud > .contenido > .titulo {
	font-weight: bold;
	font-size: 1.2em;
}

.solicitud > .contenido > .fechaCreacion {
	font-size: 0.9em;
	color: #444444;
}

.solicitud > .contenido > .fechaEvento {
	font-size: 0.9em;
	color: #444444;
}

.solicitud > .contenido > .fechaPublicacion {
	font-size: 0.9em;
	color: #444444;
}

.solicitud > .contenido > .danger {
	color: darkred;
}

.solicitud > .contenido > .destinos {
	margin-top: 15px;
}

.solicitud > .contenido > .destinos > span {
	margin-right: 10px;
	font-size: 1.5em;
	opacity: 0.6;
}

.solicitud > .avatar {
	width: 80px;
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 80px;
	align-self: center;
	text-align: center;
	padding: 5px;
}

.solicitud > .avatar > img {
	width: 60px;
	border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/modulos/solicitudes/vue/components/solicitud.vue